import { render, staticRenderFns } from "./ChallengeTopicReport.vue?vue&type=template&id=b48f6c80&scoped=true"
import script from "./ChallengeTopicReport.vue?vue&type=script&lang=ts"
export * from "./ChallengeTopicReport.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeTopicReport.vue?vue&type=style&index=0&id=b48f6c80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48f6c80",
  null
  
)

export default component.exports